import React from 'react';
import './MainSection.css';
import useUtils from '../utiles/useUtiles';
import AdminUI from './sections/roles_ui/admin/AdminUI';
// import UserUI from './sections/roles_ui/user/UserUI';
// import ClientIU from './sections/roles_ui/client/ClientUI';
// import HelperUI from './sections/roles_ui/helper/HelperUI';
import { UserStore } from '../stores/UserStore';
import { UserDetailsI } from '../utiles/interfaces'
// import { faLessThanEqual } from '@fortawesome/free-solid-svg-icons';

interface Props {
    logOut: () => void,
    isLogged: boolean
}

const MainSection = ({ logOut, isLogged }: Props): JSX.Element => {
    const { user } = useUtils();
    const userDetails: UserDetailsI | null = user();
    // Setup user store
    UserStore.update((s: UserDetailsI) => {
        s.id = userDetails && userDetails.id || null;
        s.name = userDetails && userDetails.name || '';
        s.email = userDetails && userDetails.email || '';
        s.status = userDetails && userDetails.status || '';
        s.phone = userDetails && userDetails.phone || null;
        s.phone1 = userDetails && userDetails.phone1 || '';
        s.phone2 = userDetails && userDetails.phone2 || '';
        s.role = userDetails && userDetails.role || null;
        s.isAdmin = userDetails && userDetails.isAdmin || false;
    });

    return <AdminUI />;
}

export default MainSection;
